<template>
  <div>
    <v-simple-table
      fixed-header
    >
      <template v-slot:default>
        <thead>
        <tr>
          <th>
            <v-checkbox dense
                        v-model="selectAll"
                        @change="onChangeSelectAll"/>
          </th>
          <th>Produto</th>
          <th>Quantidade</th>
          <th>Valor unitário</th>
          <th>ICMS</th>
          <th>IPI</th>
          <th>Total</th>
          <th class="text-center"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="produto in carrinho.produtos" :key="produto.id">
          <td>
            <v-checkbox
              dense
              v-model="produto.$$selecionado"/>
          </td>
          <td>
            <px-produto-descricao
              :especificacao="produto.respostaCotacaoProduto.cotacaoProduto.especificacaoProduto"
              :tooltip-truncate-chars="30"
              :produto="produto.respostaCotacaoProduto.cotacaoProduto.produto"/>
          </td>
          <td>
            {{
              produto.respostaCotacaoProduto.cotacaoProduto.quantidade
                | number(getCurrencyFormat(casaDecimal(produto)))
            }}
            {{ produto.respostaCotacaoProduto.cotacaoProduto.unidadeMedida.descricao }}
          </td>
          <td>
            <div>
              {{
                produto.respostaCotacaoProduto.valorMoedaConvertido.precoUnitario
                  | currency('R$', casaDecimal(produto))
              }}
              <div class="caption" v-if="isMoedaEstrangeira">
                {{
                  produto.respostaCotacaoProduto.precoUnitario
                    | currency(simboloMoeda, casaDecimal(produto), configuracaoFormatacaoMoeda)
                }}
              </div>
            </div>
          </td>
          <td>
            <div>
              {{
                produto.respostaCotacaoProduto.impostos.valorIcmsConvertido
                  | currency('R$', casaDecimal(produto))
              }}
              <div class="caption" v-if="isMoedaEstrangeira">
                {{
                  produto.respostaCotacaoProduto.impostos.valorIcms
                    | currency(simboloMoeda, casaDecimal(produto), configuracaoFormatacaoMoeda)
                }}
              </div>
            </div>
          </td>
          <td>
            <div>
              {{
                produto.respostaCotacaoProduto.impostos.valorIpiConvertido
                  | currency('R$', casaDecimal(produto))
              }}
              <div class="caption" v-if="isMoedaEstrangeira">
                {{
                  produto.respostaCotacaoProduto.impostos.valorIpi
                    | currency(simboloMoeda, casaDecimal(produto), configuracaoFormatacaoMoeda)
                }}
              </div>
            </div>
          </td>
          <td>
            <div>
              {{
                produto.respostaCotacaoProduto.valorMoedaConvertido.total
                  | currency('R$', casaDecimal(produto))
              }}
              <div class="caption" v-if="isMoedaEstrangeira">
                {{
                  produto.respostaCotacaoProduto.total
                    | currency(simboloMoeda, casaDecimal(produto), configuracaoFormatacaoMoeda)
                }}
              </div>
            </div>
          </td>
          <td>
            <v-tooltip top v-if="!disableActions && hasRoleComprador">
              <template v-slot:activator="{ on }">
                    <span v-on="on">
                         <v-btn icon small @click="removerProduto(produto.id)">
                            <v-icon>mdi-delete</v-icon>
                        </v-btn>
                    </span>
              </template>
              <span>Remover produto do carrinho</span>
            </v-tooltip>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>
<script>
import { CasaDecimalUtils } from 'px-components';
import { mapGetters } from 'vuex';
import moedaMixin from '@/mixins/moeda-mixin';

export default {
  mixins: [moedaMixin],
  name: 'ListagemCarrinhoProdutos',
  props: {
    carrinho: {
      type: Object,
      required: true,
    },
    disableActions: {
      default: false,
    },
    removerProduto: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      selectAll: false,
      headers: [
        {
          text: 'Produto',
          sortable: false,
          value: 'respostaCotacaoProduto.cotacaoProduto.produto.descricao',
        },
        {
          text: 'Quantidade',
          value: 'quantidade',
        },
        {
          text: 'Total',
          value: 'total',
        },
        {
          text: null,
          sortable: false,
          value: 'options',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('user', ['hasRoleComprador']),
    moeda() {
      return this.carrinho.respostaCotacao.moeda;
    },
    getCurrencyFormat() {
      return item => CasaDecimalUtils.getCurrencyFormat(item);
    },
    casaDecimal() {
      return produto => produto.respostaCotacaoProduto.cotacaoProduto.produto.casasDecimais;
    },
  },
  methods: {
    onChangeSelectAll(value) {
      this.carrinho.produtos = this.carrinho.produtos.map(produto => ({
        ...produto,
        $$selecionado: value,
      }));
    },
  },
  created() {
    this.selectAll = true;
    this.carrinho.produtos = this.carrinho.produtos.map(produto => ({
      ...produto,
      $$selecionado: this.selectAll,
    }));
  },
};
</script>
